export const INFO = {
  DEFAULT: '#0033B0',
} as const;
